mutation disableGroup($scenarioId: ID!, $originId: ID!, $groupId: ID!) {
  cube(scenarioId: $scenarioId, originId: $originId) {
    disableGroup(groupId: $groupId) {
      commited
      link {
        id
        code
      }
      validationErrors {
        ...InvalidGroupEnrollment
        ... on ExternalGroupValidation {
          allowed
          rejected_groups
          reason
          __typename
        }
        __typename
      }
    }
  }
}

fragment InvalidGroupEnrollment on InvalidGroupEnrollment {
  reason
}
